export default {
  namespaced: true,
  state: {
    step1: {},

    step2: {},

    showroomPeriod: {},
    showroomPeriodEnabled: [],
    showroomPeriodDisabled: [],
    forPolicy: {}
  },

  mutations: {
    SET_STEP1 (state, payload) {
      state.step1 = payload
    },

    SET_STEP2 (state, payload) {
      state.step2 = payload
    },

    CLEAR_STEP1 (state) {
      state.step1 = {}
    },

    CLEAR_STEP2 (state, payload) {
      state.step2 = {}
    },

    SET_SHOWROOM_PERIOD (state, payload) {
      state.showroomPeriod = payload
      state.showroomPeriodEnabled = _.get(payload, 'enabled', '')
      state.showroomPeriodDisabled = _.get(payload, 'disabled', '')
    },

    CLEAR_SHOWROOM_PERIOD (state) {
      state.showroomPeriod = {}
      state.showroomPeriodEnabled = []
      state.showroomPeriodDisabled = []
    },

    SET_FOR_POLICY (state, payload) {
      state.forPolicy = payload
    },

    CLEAR_FOR_POLICY (state) {
      state.forPolicy = {}
    }
  }
}
